module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY10.9e0f1fc0.jpg";